import dompurify from 'dompurify'

export const sanitize = (val: string, allowedTags?: string[], allowedAttrs: string[] = []) => {
  if (allowedAttrs.includes('target')) {
    // As a security measure, ensure that all links with target="_blank" have rel="noreferrer"
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#security_and_privacy
    dompurify.addHook('afterSanitizeAttributes', node => {
      if (node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noreferrer')
      }
    })
  }
  const result = dompurify.sanitize(val, {
    USE_PROFILES: allowedTags ? undefined : { html: true },
    ALLOWED_TAGS: allowedTags ?? [], // It needs an empty array fallback, otherwise 'dompurify' will throw an error
    ADD_ATTR: allowedAttrs,
  })
  dompurify.removeAllHooks()
  return result
}
